import { MapPin } from "lucide-react";

export const ServiceArea = () => {
  return (
    <section
      data-testid="service-area-section"
      className="py-24 md:py-28 bg-[#0A192F] relative overflow-hidden"
    >
      <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[#0077E6]/20 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-[#0077E6]/10 blur-3xl" />

      <div className="relative mx-auto max-w-4xl px-5 sm:px-8 text-center">
        <div className="inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-[#0077E6]/15 text-[#5CB3FF] mb-8">
          <MapPin className="h-8 w-8" />
        </div>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white">
          Unser Einsatzgebiet
        </h2>
        <p className="mt-6 text-base md:text-lg text-slate-300 leading-relaxed max-w-2xl mx-auto">
          Wir sind in Leonberg, Ditzingen und der näheren Umgebung für Sie im
          Einsatz.
        </p>

        <div className="mt-10 flex flex-wrap justify-center gap-3">
          {["Leonberg", "Ditzingen", "Umgebung"].map((c) => (
            <span
              key={c}
              className="rounded-full border border-white/15 bg-white/5 px-6 py-2.5 text-sm font-semibold text-white"
            >
              {c}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
